(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './core-core-api.js', './core-core-stl.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./core-core-api.js'), require('./core-core-stl.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-test-helpers'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-test-helpers'.");
    }
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core-test-helpers'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core-test-helpers'.");
    }
    if (typeof this['core-core-stl'] === 'undefined') {
      throw new Error("Error loading module 'core-test-helpers'. Its dependency 'core-core-stl' was not found. Please, check whether 'core-core-stl' is loaded prior to 'core-test-helpers'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'core-test-helpers'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'core-test-helpers'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'core-test-helpers'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'core-test-helpers'.");
    }
    root['core-test-helpers'] = factory(typeof this['core-test-helpers'] === 'undefined' ? {} : this['core-test-helpers'], this['kotlin-kotlin-stdlib'], this['core-core-api'], this['core-core-stl'], this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_core_core_api, kotlin_core_core_stl, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.u9;
  var VOID = kotlin_kotlin.$_$.e;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var first = kotlin_kotlin.$_$.v5;
  var get_collider = kotlin_core_core_api.$_$.d1;
  var get_worldPosition = kotlin_core_core_api.$_$.l7;
  var toString = kotlin_kotlin.$_$.z9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var get_displayName = kotlin_core_core_api.$_$.h5;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var get_colliderShapeComponent = kotlin_core_core_api.$_$.e1;
  var get_connectorsComponent = kotlin_core_core_api.$_$.h2;
  var emptyList = kotlin_kotlin.$_$.o5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var sortedWith = kotlin_kotlin.$_$.m7;
  var last = kotlin_kotlin.$_$.l6;
  var Comparator = kotlin_kotlin.$_$.pc;
  var classMeta = kotlin_kotlin.$_$.q8;
  var compareValues = kotlin_kotlin.$_$.d8;
  var defineProp = kotlin_kotlin.$_$.s8;
  var ensureNotNull = kotlin_kotlin.$_$.qd;
  var AutoAdaptHostComponent = kotlin_core_core_stl.$_$.l;
  var get_productRef = kotlin_core_core_api.$_$.w;
  var AutoAdaptGuestComponent = kotlin_core_core_stl.$_$.k;
  var Companion_instance = kotlin_core_core_stl.$_$.e4;
  var contains = kotlin_kotlin.$_$.x4;
  var get_snapRoot = kotlin_core_core_api.$_$.i1;
  var Companion_instance_0 = kotlin_core_core_stl.$_$.m4;
  var Companion_instance_1 = kotlin_core_core_api.$_$.fd;
  var SystemBase = kotlin_core_core_api.$_$.e3;
  var ComponentIds_instance = kotlin_core_core_api.$_$.w9;
  var RoomGeometryData = kotlin_core_core_stl.$_$.x2;
  var RoomPoint3D = kotlin_core_core_stl.$_$.z2;
  var RoomSurface = kotlin_core_core_stl.$_$.c3;
  var RoomEdge = kotlin_core_core_stl.$_$.w2;
  var RoomCorner = kotlin_core_core_stl.$_$.v2;
  var RoomObstacle = kotlin_core_core_stl.$_$.y2;
  var RoomBoundingBox = kotlin_core_core_stl.$_$.t2;
  var RoomTransform = kotlin_core_core_stl.$_$.d3;
  var RoomRotation = kotlin_core_core_stl.$_$.a3;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var getKClass = kotlin_kotlin.$_$.d;
  var arrayOf = kotlin_kotlin.$_$.nd;
  var createKType = kotlin_kotlin.$_$.a;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b3;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var isInterface = kotlin_kotlin.$_$.j9;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var objectCreate = kotlin_kotlin.$_$.s9;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ArrangeExtensions, 'ArrangeExtensions', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(AutoAdaptExtensions, 'AutoAdaptExtensions', objectMeta);
  setMetadataFor(PlacementExtensions, 'PlacementExtensions', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(CountSystem, 'CountSystem', classMeta, SystemBase, VOID, CountSystem);
  setMetadataFor(RoomGeneratorUtils$createRoomFromData$1, VOID, classMeta, VOID, [RoomGeometryData]);
  setMetadataFor(RoomGeneratorUtils$point$1, VOID, classMeta, VOID, [RoomPoint3D]);
  setMetadataFor(RoomGeneratorUtils$surfaces$1$1, VOID, classMeta, VOID, [RoomSurface]);
  setMetadataFor(RoomGeneratorUtils$edges$1$1, VOID, classMeta, VOID, [RoomEdge]);
  setMetadataFor(RoomGeneratorUtils$corners$1$1, VOID, classMeta, VOID, [RoomCorner]);
  setMetadataFor(RoomGeneratorUtils$obstacles$1$1, VOID, classMeta, VOID, [RoomObstacle]);
  setMetadataFor(RoomGeneratorUtils$boundingBox$1, VOID, classMeta, VOID, [RoomBoundingBox]);
  setMetadataFor(RoomGeneratorUtils$transform$1, VOID, classMeta, VOID, [RoomTransform]);
  setMetadataFor(RoomGeneratorUtils$rotation$1, VOID, classMeta, VOID, [RoomRotation]);
  setMetadataFor(RoomGeneratorUtils, 'RoomGeneratorUtils', objectMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomGeometryDataTestImpl, 'RoomGeometryDataTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomSurfaceTestImpl, 'RoomSurfaceTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomEdgeTestImpl, 'RoomEdgeTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomCornerTestImpl, 'RoomCornerTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomPoint3DTestImpl, 'RoomPoint3DTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomObstacleTestImpl, 'RoomObstacleTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomRotationTestImpl, 'RoomRotationTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomBoundingBoxTestImpl, 'RoomBoundingBoxTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomTransformTestImpl, 'RoomTransformTestImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(RoomGeometryDataImpl, 'RoomGeometryDataImpl', classMeta, VOID, [RoomGeometryData]);
  setMetadataFor(RoomSurfaceImpl, 'RoomSurfaceImpl', classMeta, VOID, [RoomSurface]);
  setMetadataFor(RoomEdgeImpl, 'RoomEdgeImpl', classMeta, VOID, [RoomEdge]);
  setMetadataFor(RoomCornerImpl, 'RoomCornerImpl', classMeta, VOID, [RoomCorner]);
  setMetadataFor(RoomPoint3DImpl, 'RoomPoint3DImpl', classMeta, VOID, [RoomPoint3D]);
  //endregion
  function ArrangeExtensions() {
  }
  protoOf(ArrangeExtensions).e4d = function (_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt) {
    return placeHostProductsInLine(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt);
  };
  protoOf(ArrangeExtensions).placeHostProductsInLine = function (_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt, $super) {
    doAutoAdapt = doAutoAdapt === VOID ? true : doAutoAdapt;
    return this.e4d(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt);
  };
  var ArrangeExtensions_instance;
  function ArrangeExtensions_getInstance() {
    return ArrangeExtensions_instance;
  }
  function placeHostProductsInLine(_this__u8e3s4, productRef, numOfProducts, coreServices, doAutoAdapt) {
    doAutoAdapt = doAutoAdapt === VOID ? true : doAutoAdapt;
    var inductionVariable = 1;
    if (inductionVariable <= numOfProducts)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var product = createInSceneAndAssert(_this__u8e3s4, productRef, coreServices);
        if (doAutoAdapt) {
          makeAutoAdaptHost(product, coreServices);
        }
      }
       while (!(i === numOfProducts));
    var productsLeftToRight = getProductInOrderLeftToRight(coreServices.sceneManager, productRef);
    assertOrderedXPlacedOnInterval(productsLeftToRight, coreServices);
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(productsLeftToRight);
  }
  function assertOrderedXPlacedOnInterval(orderedLeftToRight, coreServices) {
    var tmp0_safe_receiver = get_collider(first(orderedLeftToRight));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
    var width = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.width;
    var alignWidth = getAlignWidth(first(orderedLeftToRight));
    var pos = get_worldPosition(first(orderedLeftToRight)).X;
    var iterator = orderedLeftToRight.t();
    var index = 0;
    while (iterator.u()) {
      var i = index;
      index = index + 1 | 0;
      var product = iterator.w();
      var tmp;
      if (width == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.test.helper.extensions.assertOrderedXPlacedOnInterval.<anonymous>' call
        tmp = pos + width * i;
      }
      var expectedBasedOnCollider = tmp;
      var tmp_0;
      if (alignWidth == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.test.helper.extensions.assertOrderedXPlacedOnInterval.<anonymous>' call
        tmp_0 = pos + alignWidth * i;
      }
      var expectedBasedOnAlignments = tmp_0;
      var actual = get_worldPosition(product).X;
      if (!(expectedBasedOnCollider == null) ? !(expectedBasedOnAlignments == null) : false) {
        // Inline function 'kotlin.math.abs' call
        var x = expectedBasedOnCollider - actual;
        var outcome1 = Math.abs(x) < 0.001;
        // Inline function 'kotlin.math.abs' call
        var x_0 = expectedBasedOnAlignments - actual;
        var outcome2 = Math.abs(x_0) < 0.001;
        if (!outcome1 ? !outcome2 : false) {
          // Inline function 'kotlin.error' call
          var message = 'Expect to be equal. Expected: ' + expectedBasedOnCollider + ' (collider) or ' + expectedBasedOnAlignments + ' (alignments) actual: ' + actual;
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
      coreServices.entityManager.addComponent(product, new DisplayNameComponent('Product ' + (i + 1 | 0) + ' ' + get_displayName(product)));
    }
  }
  function getAlignWidth(entity) {
    var tmp0_safe_receiver = get_colliderShapeComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.width;
    var width = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var tmp4_safe_receiver = get_connectorsComponent(entity);
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.alignmentConnectors;
    var alignmentConnectors = tmp5_elvis_lhs == null ? emptyList() : tmp5_elvis_lhs;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = alignmentConnectors.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.test.helper.extensions.getAlignWidth.<anonymous>' call
      // Inline function 'kotlin.math.abs' call
      var x = element.transform.position.X;
      if (Math.abs(x) >= width / 2) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = getAlignWidth$lambda;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    var fromLeftToRight = sortedWith(destination, tmp$ret$4);
    var tmp_0;
    if (fromLeftToRight.n() >= 2) {
      // Inline function 'kotlin.math.abs' call
      var x_0 = first(fromLeftToRight).transform.position.X - last(fromLeftToRight).transform.position.X;
      tmp_0 = Math.abs(x_0);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.f4d_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.f4d_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function getAlignWidth$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.test.helper.extensions.getAlignWidth.<anonymous>' call
    var tmp = a.transform.position.X;
    // Inline function 'com.ikea.core.test.helper.extensions.getAlignWidth.<anonymous>' call
    var tmp$ret$1 = b.transform.position.X;
    return compareValues(tmp, tmp$ret$1);
  }
  function AutoAdaptExtensions() {
  }
  protoOf(AutoAdaptExtensions).makeAutoAdaptHost = function (_this__u8e3s4, coreServices) {
    return makeAutoAdaptHost(_this__u8e3s4, coreServices);
  };
  protoOf(AutoAdaptExtensions).makeAutoAdaptable = function (_this__u8e3s4, alternativeProductRefs, coreServices) {
    return makeAutoAdaptable(_this__u8e3s4, alternativeProductRefs, coreServices);
  };
  var AutoAdaptExtensions_instance;
  function AutoAdaptExtensions_getInstance() {
    return AutoAdaptExtensions_instance;
  }
  function makeAutoAdaptHost(_this__u8e3s4, coreServices) {
    coreServices.entityManager.addComponent(_this__u8e3s4, new AutoAdaptHostComponent(ensureNotNull(get_colliderShapeComponent(_this__u8e3s4)).polyhedron));
  }
  function makeAutoAdaptable(_this__u8e3s4, alternativeProductRefs, coreServices) {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [ensureNotNull(get_productRef(_this__u8e3s4))];
    var originalProductRefs = alternativeProductRefs.concat(tmp$ret$3);
    _this__u8e3s4.addComponent(new AutoAdaptGuestComponent(originalProductRefs));
    coreServices.productManager.subscribeProductCreated(makeAutoAdaptable$lambda(originalProductRefs));
  }
  function makeAutoAdaptable$lambda($originalProductRefs) {
    return function (createdEntity, productRef) {
      var tmp;
      var tmp_0;
      if (!createdEntity.hasComponent(126)) {
        tmp_0 = contains($originalProductRefs, productRef);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        createdEntity.addComponent(new AutoAdaptGuestComponent($originalProductRefs));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PlacementExtensions() {
  }
  protoOf(PlacementExtensions).createInSceneAndAssert = function (_this__u8e3s4, productRef, coreServices) {
    return createInSceneAndAssert(_this__u8e3s4, productRef, coreServices);
  };
  protoOf(PlacementExtensions).createInHostAndAssert = function (_this__u8e3s4, productRef, host, coreServices) {
    return createInHostAndAssert(_this__u8e3s4, productRef, host, coreServices);
  };
  protoOf(PlacementExtensions).createInScene = function (_this__u8e3s4, productRef, coreServices) {
    return createInScene(_this__u8e3s4, productRef, coreServices);
  };
  protoOf(PlacementExtensions).createInHost = function (_this__u8e3s4, entity, host, coreServices) {
    return createInHost(_this__u8e3s4, entity, host, coreServices);
  };
  protoOf(PlacementExtensions).createAtPosition = function (_this__u8e3s4, entity, position, coreServices) {
    return createAtPosition(_this__u8e3s4, entity, position, coreServices);
  };
  protoOf(PlacementExtensions).createAtPositionAndAssert = function (_this__u8e3s4, productRef, position, coreServices) {
    return createAtPositionAndAssert(_this__u8e3s4, productRef, position, coreServices);
  };
  protoOf(PlacementExtensions).fillHostWithProduct = function (_this__u8e3s4, productRef, host, coreServices) {
    return fillHostWithProduct(_this__u8e3s4, productRef, host, coreServices);
  };
  var PlacementExtensions_instance;
  function PlacementExtensions_getInstance() {
    return PlacementExtensions_instance;
  }
  function createInSceneAndAssert(_this__u8e3s4, productRef, coreServices) {
    var result = createInScene(_this__u8e3s4, productRef, coreServices);
    if (!result.valid) {
      // Inline function 'kotlin.error' call
      var message = 'Could not place product: ' + result;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var x = ensureNotNull(result.placedEntity);
    var tmp0_elvis_lhs = get_snapRoot(x);
    return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
  }
  function createInHostAndAssert(_this__u8e3s4, productRef, host, coreServices) {
    var result = createInHost(_this__u8e3s4, productRef, host, coreServices);
    if (!result.valid) {
      // Inline function 'kotlin.error' call
      var message = 'Could not place product (' + productRef + ') in host ' + host.id + ': ' + result;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var x = ensureNotNull(result.placedEntity);
    var tmp0_elvis_lhs = get_snapRoot(x);
    return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
  }
  function createAndAlignToTargetAndAssert(_this__u8e3s4, productRef, alignTarget, entityAlignmentConnectorKey, targetAlignmentConnectorKey, coreServices) {
    var result = createAndSnapToSceneWithAlignment(_this__u8e3s4, productRef, alignTarget, entityAlignmentConnectorKey, targetAlignmentConnectorKey, coreServices);
    if (!result.valid) {
      // Inline function 'kotlin.error' call
      var message = 'Could not place product (' + productRef + ') in host ' + alignTarget.id + ': ' + result;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var x = ensureNotNull(result.placedEntity);
    var tmp0_elvis_lhs = get_snapRoot(x);
    return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
  }
  function createInScene(_this__u8e3s4, productRef, coreServices) {
    var tmp0_elvis_lhs = coreServices.productManager.createEntity(productRef);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Could not create product ' + productRef;
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var productEntity = tmp;
    return _this__u8e3s4.snapToScene(productEntity);
  }
  function createInHost(_this__u8e3s4, entity, host, coreServices) {
    var productEntity = coreServices.productManager.createEntity(entity);
    var tmp;
    if (productEntity == null) {
      var tmp_0 = Companion_instance_0;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [Companion_instance_1.fail('No product found with ref', entity)];
      tmp = tmp_0.failWithErrors(tmp$ret$2);
    } else {
      return _this__u8e3s4.snapToTarget(productEntity, host);
    }
    return tmp;
  }
  function createAndSnapToSceneWithAlignment(_this__u8e3s4, entity, alignTarget, entityAlignmentConnectorKey, targetAlignmentConnectorKey, coreServices) {
    var productEntity = coreServices.productManager.createEntity(entity);
    var tmp;
    if (productEntity == null) {
      var tmp_0 = Companion_instance_0;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [Companion_instance_1.fail('No product found with ref', entity)];
      tmp = tmp_0.failWithErrors(tmp$ret$2);
    } else {
      return _this__u8e3s4.alignToTargetSpecificConnectors(productEntity, entityAlignmentConnectorKey, alignTarget, targetAlignmentConnectorKey);
    }
    return tmp;
  }
  function createAtPosition(_this__u8e3s4, productRef, position, coreServices) {
    var productEntity = coreServices.productManager.createEntity(productRef);
    var tmp;
    if (productEntity == null) {
      var tmp_0 = Companion_instance_0;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [Companion_instance_1.fail('No product found with ref', productRef)];
      tmp = tmp_0.failWithErrors(tmp$ret$2);
    } else {
      tmp = _this__u8e3s4.snapToPosition(productEntity, position, false);
    }
    return tmp;
  }
  function createAtPositionAllowWarnings(_this__u8e3s4, productRef, position, coreServices) {
    var productEntity = ensureNotNull(coreServices.productManager.createEntity(productRef));
    return _this__u8e3s4.snapToPosition(productEntity, position, true);
  }
  function createAtPositionAndAssert(_this__u8e3s4, productRef, position, coreServices) {
    var result = createAtPosition(_this__u8e3s4, productRef, position, coreServices);
    if (!result.valid) {
      // Inline function 'kotlin.error' call
      var message = 'Could not place product (' + productRef + ') at ' + position + ': ' + result;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var x = ensureNotNull(result.placedEntity);
    var tmp0_elvis_lhs = get_snapRoot(x);
    return tmp0_elvis_lhs == null ? x : tmp0_elvis_lhs;
  }
  function fillHostWithProduct(_this__u8e3s4, productRef, host, coreServices) {
    var valid = true;
    while (valid) {
      var result = createInHost(_this__u8e3s4, productRef, host, coreServices);
      valid = result.valid;
    }
  }
  function getProductInOrderLeftToRight(_this__u8e3s4, ref) {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = _this__u8e3s4.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.extensions.getProductInOrderLeftToRight.<anonymous>' call
      if (get_productRef(element) === ref) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = getProductInOrderLeftToRight$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp);
    return sortedWith(destination, tmp$ret$3);
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.g4d_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).u1j = function (a, b) {
    return this.g4d_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function getProductInOrderLeftToRight$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.test.helper.extensions.getProductInOrderLeftToRight.<anonymous>' call
    var tmp = get_worldPosition(a).X;
    // Inline function 'com.ikea.core.test.helper.extensions.getProductInOrderLeftToRight.<anonymous>' call
    var tmp$ret$1 = get_worldPosition(b).X;
    return compareValues(tmp, tmp$ret$1);
  }
  function CountSystem() {
    SystemBase.call(this, 'CountSystem', 0);
    this.enable();
    this.addCount = 0;
    this.updateCount = 0;
    this.removeCount = 0;
  }
  protoOf(CountSystem).p4d = function (_set____db54di) {
    this.addCount = _set____db54di;
  };
  protoOf(CountSystem).q4d = function () {
    return this.addCount;
  };
  protoOf(CountSystem).r4d = function (_set____db54di) {
    this.updateCount = _set____db54di;
  };
  protoOf(CountSystem).s4d = function () {
    return this.updateCount;
  };
  protoOf(CountSystem).t4d = function (_set____db54di) {
    this.removeCount = _set____db54di;
  };
  protoOf(CountSystem).u4d = function () {
    return this.removeCount;
  };
  protoOf(CountSystem).onAddComponent = function (entity, newComponent) {
    this.addCount = this.addCount + 1 | 0;
  };
  protoOf(CountSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.updateCount = this.updateCount + 1 | 0;
  };
  protoOf(CountSystem).onRemoveComponent = function (entity, oldComponent) {
    this.removeCount = this.removeCount + 1 | 0;
  };
  protoOf(CountSystem).reset = function () {
    this.addCount = 0;
    this.updateCount = 0;
    this.removeCount = 0;
  };
  protoOf(CountSystem).w1o = function () {
    // Inline function 'kotlin.emptyArray' call
    return [];
  };
  function createRoomFromData($this, data) {
    return new RoomGeneratorUtils$createRoomFromData$1(data);
  }
  function boundingBox($this, boundingBox) {
    return new RoomGeneratorUtils$boundingBox$1(boundingBox);
  }
  function transform($this, transform) {
    return new RoomGeneratorUtils$transform$1(transform);
  }
  function rotation($this, rotation) {
    return new RoomGeneratorUtils$rotation$1(rotation);
  }
  function RoomGeneratorUtils$createRoom$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function RoomGeneratorUtils$createRoomFromData$1($data) {
    this.v4d_1 = RoomGeneratorUtils_instance.surfaces($data);
    this.w4d_1 = RoomGeneratorUtils_instance.edges($data);
    this.x4d_1 = RoomGeneratorUtils_instance.corners($data);
    this.y4d_1 = RoomGeneratorUtils_instance.obstacles($data);
  }
  protoOf(RoomGeneratorUtils$createRoomFromData$1).l23 = function () {
    return this.v4d_1;
  };
  protoOf(RoomGeneratorUtils$createRoomFromData$1).n3j = function () {
    return this.w4d_1;
  };
  protoOf(RoomGeneratorUtils$createRoomFromData$1).r3k = function () {
    return this.x4d_1;
  };
  protoOf(RoomGeneratorUtils$createRoomFromData$1).o3j = function () {
    return this.y4d_1;
  };
  function RoomGeneratorUtils$point$1($p) {
    this.z4d_1 = $p.x;
    this.a4e_1 = $p.y;
    this.b4e_1 = $p.z;
  }
  protoOf(RoomGeneratorUtils$point$1).i2d = function () {
    return this.z4d_1;
  };
  protoOf(RoomGeneratorUtils$point$1).j2d = function () {
    return this.a4e_1;
  };
  protoOf(RoomGeneratorUtils$point$1).k2d = function () {
    return this.b4e_1;
  };
  function RoomGeneratorUtils$surfaces$1$1($it) {
    this.c4e_1 = $it.id;
    this.d4e_1 = $it.type;
    this.e4e_1 = RoomGeneratorUtils_instance.vertices($it.vertices);
  }
  protoOf(RoomGeneratorUtils$surfaces$1$1).s1k = function () {
    return this.c4e_1;
  };
  protoOf(RoomGeneratorUtils$surfaces$1$1).a1x = function () {
    return this.d4e_1;
  };
  protoOf(RoomGeneratorUtils$surfaces$1$1).b23 = function () {
    return this.e4e_1;
  };
  function RoomGeneratorUtils$edges$1$1($it) {
    this.f4e_1 = $it.id;
    this.g4e_1 = $it.surface1;
    this.h4e_1 = $it.surface2;
    this.i4e_1 = RoomGeneratorUtils_instance.point($it.vertex1);
    this.j4e_1 = RoomGeneratorUtils_instance.point($it.vertex2);
  }
  protoOf(RoomGeneratorUtils$edges$1$1).s1k = function () {
    return this.f4e_1;
  };
  protoOf(RoomGeneratorUtils$edges$1$1).s3k = function () {
    return this.g4e_1;
  };
  protoOf(RoomGeneratorUtils$edges$1$1).t3k = function () {
    return this.h4e_1;
  };
  protoOf(RoomGeneratorUtils$edges$1$1).u3k = function () {
    return this.i4e_1;
  };
  protoOf(RoomGeneratorUtils$edges$1$1).v3k = function () {
    return this.j4e_1;
  };
  function RoomGeneratorUtils$corners$1$1($it) {
    this.k4e_1 = $it.id;
    this.l4e_1 = RoomGeneratorUtils_instance.point($it.position);
    this.m4e_1 = $it.edges;
    this.n4e_1 = $it.surfaces;
  }
  protoOf(RoomGeneratorUtils$corners$1$1).s1k = function () {
    return this.k4e_1;
  };
  protoOf(RoomGeneratorUtils$corners$1$1).ct = function () {
    return this.l4e_1;
  };
  protoOf(RoomGeneratorUtils$corners$1$1).n3j = function () {
    return this.m4e_1;
  };
  protoOf(RoomGeneratorUtils$corners$1$1).l23 = function () {
    return this.n4e_1;
  };
  function RoomGeneratorUtils$obstacles$1$1($it) {
    this.o4e_1 = $it.id;
    this.p4e_1 = $it.type;
    this.q4e_1 = boundingBox(RoomGeneratorUtils_instance, $it.boundingBox);
  }
  protoOf(RoomGeneratorUtils$obstacles$1$1).s1k = function () {
    return this.o4e_1;
  };
  protoOf(RoomGeneratorUtils$obstacles$1$1).a1x = function () {
    return this.p4e_1;
  };
  protoOf(RoomGeneratorUtils$obstacles$1$1).m3k = function () {
    return this.q4e_1;
  };
  function RoomGeneratorUtils$boundingBox$1($boundingBox) {
    this.r4e_1 = RoomGeneratorUtils_instance.point($boundingBox.size);
    this.s4e_1 = transform(RoomGeneratorUtils_instance, $boundingBox.transform);
  }
  protoOf(RoomGeneratorUtils$boundingBox$1).n = function () {
    return this.r4e_1;
  };
  protoOf(RoomGeneratorUtils$boundingBox$1).d1x = function () {
    return this.s4e_1;
  };
  function RoomGeneratorUtils$transform$1($transform) {
    this.t4e_1 = RoomGeneratorUtils_instance.point($transform.position);
    this.u4e_1 = rotation(RoomGeneratorUtils_instance, $transform.rotation);
  }
  protoOf(RoomGeneratorUtils$transform$1).ct = function () {
    return this.t4e_1;
  };
  protoOf(RoomGeneratorUtils$transform$1).v1k = function () {
    return this.u4e_1;
  };
  function RoomGeneratorUtils$rotation$1($rotation) {
    this.v4e_1 = $rotation.x;
    this.w4e_1 = $rotation.y;
    this.x4e_1 = $rotation.z;
    this.y4e_1 = $rotation.w;
  }
  protoOf(RoomGeneratorUtils$rotation$1).i2d = function () {
    return this.v4e_1;
  };
  protoOf(RoomGeneratorUtils$rotation$1).j2d = function () {
    return this.w4e_1;
  };
  protoOf(RoomGeneratorUtils$rotation$1).k2d = function () {
    return this.x4e_1;
  };
  protoOf(RoomGeneratorUtils$rotation$1).h2d = function () {
    return this.y4e_1;
  };
  function RoomGeneratorUtils() {
  }
  protoOf(RoomGeneratorUtils).createRoom = function (json) {
    var serializer_0 = Json(VOID, RoomGeneratorUtils$createRoom$lambda);
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    // Inline function 'kotlinx.serialization.serializer' call
    var this_0 = serializer_0.co();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer(this_0, createKType(getKClass(RoomGeometryDataTestImpl), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    var data = serializer_0.j15(tmp$ret$1, json);
    return createRoomFromData(this, data);
  };
  protoOf(RoomGeneratorUtils).roomPoint3D = function (vector) {
    return new RoomPoint3DImpl(vector.X, vector.Y, vector.Z);
  };
  protoOf(RoomGeneratorUtils).point = function (p) {
    return new RoomGeneratorUtils$point$1(p);
  };
  protoOf(RoomGeneratorUtils).vertices = function (verts) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(verts.length);
    var inductionVariable = 0;
    var last = verts.length;
    while (inductionVariable < last) {
      var item = verts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0 = RoomGeneratorUtils_instance.point(item);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(RoomGeneratorUtils).surfaces = function (room) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = room.surfaces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.utils.RoomGeneratorUtils.surfaces.<anonymous>' call
      var tmp$ret$0 = new RoomGeneratorUtils$surfaces$1$1(item);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(RoomGeneratorUtils).edges = function (room) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = room.edges;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.utils.RoomGeneratorUtils.edges.<anonymous>' call
      var tmp$ret$0 = new RoomGeneratorUtils$edges$1$1(item);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(RoomGeneratorUtils).corners = function (room) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = room.corners;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.test.helper.utils.RoomGeneratorUtils.corners.<anonymous>' call
      var tmp$ret$0 = new RoomGeneratorUtils$corners$1$1(item);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(RoomGeneratorUtils).obstacles = function (room) {
    var tmp0_safe_receiver = room.obstacles;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.test.helper.utils.RoomGeneratorUtils.obstacles.<anonymous>' call
        var tmp$ret$0 = new RoomGeneratorUtils$obstacles$1$1(item);
        destination.q(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  };
  var RoomGeneratorUtils_instance;
  function RoomGeneratorUtils_getInstance() {
    return RoomGeneratorUtils_instance;
  }
  function Companion() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z4e_1 = [new ReferenceArraySerializer(getKClass(RoomSurfaceTestImpl), $serializer_getInstance_0()), new ReferenceArraySerializer(getKClass(RoomEdgeTestImpl), $serializer_getInstance_1()), new ReferenceArraySerializer(getKClass(RoomCornerTestImpl), $serializer_getInstance_2()), new ReferenceArraySerializer(getKClass(RoomObstacleTestImpl), $serializer_getInstance_4())];
  }
  protoOf(Companion).l17 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance_2;
  function Companion_getInstance() {
    if (Companion_instance_2 == null)
      new Companion();
    return Companion_instance_2;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomGeometryDataTestImpl', this, 4);
    tmp0_serialDesc.cv('surfaces', false);
    tmp0_serialDesc.cv('edges', false);
    tmp0_serialDesc.cv('corners', false);
    tmp0_serialDesc.cv('obstacles', true);
    this.a4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ok = function () {
    return this.a4f_1;
  };
  protoOf($serializer).rv = function () {
    var tmp0_cached = Companion_getInstance().z4e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], get_nullable(tmp0_cached[3])];
  };
  protoOf($serializer).qk = function (decoder) {
    var tmp0_desc = this.a4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance().z4e_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.zn(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.bo(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zn(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.bo(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return RoomGeometryDataTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer).b4f = function (encoder, value) {
    var tmp0_desc = this.a4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance().z4e_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.surfaces);
    tmp1_output.ep(tmp0_desc, 1, tmp2_cached[1], value.edges);
    tmp1_output.ep(tmp0_desc, 2, tmp2_cached[2], value.corners);
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.obstacles == null)) {
      tmp1_output.gp(tmp0_desc, 3, tmp2_cached[3], value.obstacles);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer).pk = function (encoder, value) {
    return this.b4f(encoder, value instanceof RoomGeometryDataTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function RoomGeometryDataTestImpl_init_$Init$(seen1, surfaces, edges, corners, obstacles, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance().a4f_1);
    }
    $this.surfaces = surfaces;
    $this.edges = edges;
    $this.corners = corners;
    if (0 === (seen1 & 8))
      $this.obstacles = null;
    else
      $this.obstacles = obstacles;
    return $this;
  }
  function RoomGeometryDataTestImpl_init_$Create$(seen1, surfaces, edges, corners, obstacles, serializationConstructorMarker) {
    return RoomGeometryDataTestImpl_init_$Init$(seen1, surfaces, edges, corners, obstacles, serializationConstructorMarker, objectCreate(protoOf(RoomGeometryDataTestImpl)));
  }
  function RoomGeometryDataTestImpl(surfaces, edges, corners, obstacles) {
    Companion_getInstance();
    obstacles = obstacles === VOID ? null : obstacles;
    this.surfaces = surfaces;
    this.edges = edges;
    this.corners = corners;
    this.obstacles = obstacles;
  }
  protoOf(RoomGeometryDataTestImpl).l23 = function () {
    return this.surfaces;
  };
  protoOf(RoomGeometryDataTestImpl).n3j = function () {
    return this.edges;
  };
  protoOf(RoomGeometryDataTestImpl).r3k = function () {
    return this.corners;
  };
  protoOf(RoomGeometryDataTestImpl).o3j = function () {
    return this.obstacles;
  };
  function Companion_0() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4f_1 = [null, null, new ReferenceArraySerializer(getKClass(RoomPoint3DTestImpl), $serializer_getInstance_3())];
  }
  protoOf(Companion_0).l17 = function () {
    return $serializer_getInstance_0();
  };
  var Companion_instance_3;
  function Companion_getInstance_0() {
    if (Companion_instance_3 == null)
      new Companion_0();
    return Companion_instance_3;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomSurfaceTestImpl', this, 3);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('type', false);
    tmp0_serialDesc.cv('vertices', false);
    this.d4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ok = function () {
    return this.d4f_1;
  };
  protoOf($serializer_0).rv = function () {
    var tmp0_cached = Companion_getInstance_0().c4f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2]];
  };
  protoOf($serializer_0).qk = function (decoder) {
    var tmp0_desc = this.d4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    var tmp8_cached = Companion_getInstance_0().c4f_1;
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return RoomSurfaceTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).e4f = function (encoder, value) {
    var tmp0_desc = this.d4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_0().c4f_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.type);
    tmp1_output.ep(tmp0_desc, 2, tmp2_cached[2], value.vertices);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_0).pk = function (encoder, value) {
    return this.e4f(encoder, value instanceof RoomSurfaceTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function RoomSurfaceTestImpl_init_$Init$(seen1, id, type, vertices, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_0().d4f_1);
    }
    $this.id = id;
    $this.type = type;
    $this.vertices = vertices;
    return $this;
  }
  function RoomSurfaceTestImpl_init_$Create$(seen1, id, type, vertices, serializationConstructorMarker) {
    return RoomSurfaceTestImpl_init_$Init$(seen1, id, type, vertices, serializationConstructorMarker, objectCreate(protoOf(RoomSurfaceTestImpl)));
  }
  function RoomSurfaceTestImpl(id, type, vertices) {
    Companion_getInstance_0();
    this.id = id;
    this.type = type;
    this.vertices = vertices;
  }
  protoOf(RoomSurfaceTestImpl).s1k = function () {
    return this.id;
  };
  protoOf(RoomSurfaceTestImpl).a1x = function () {
    return this.type;
  };
  protoOf(RoomSurfaceTestImpl).b23 = function () {
    return this.vertices;
  };
  function Companion_1() {
  }
  protoOf(Companion_1).l17 = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_4;
  function Companion_getInstance_1() {
    return Companion_instance_4;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomEdgeTestImpl', this, 5);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('surface1', false);
    tmp0_serialDesc.cv('surface2', false);
    tmp0_serialDesc.cv('vertex1', false);
    tmp0_serialDesc.cv('vertex2', false);
    this.f4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ok = function () {
    return this.f4f_1;
  };
  protoOf($serializer_1).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_3(), $serializer_getInstance_3()];
  };
  protoOf($serializer_1).qk = function (decoder) {
    var tmp0_desc = this.f4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zn(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zn(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return RoomEdgeTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_1).g4f = function (encoder, value) {
    var tmp0_desc = this.f4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.surface1);
    tmp1_output.cp(tmp0_desc, 2, value.surface2);
    tmp1_output.ep(tmp0_desc, 3, $serializer_getInstance_3(), value.vertex1);
    tmp1_output.ep(tmp0_desc, 4, $serializer_getInstance_3(), value.vertex2);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_1).pk = function (encoder, value) {
    return this.g4f(encoder, value instanceof RoomEdgeTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RoomEdgeTestImpl_init_$Init$(seen1, id, surface1, surface2, vertex1, vertex2, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_1().f4f_1);
    }
    $this.id = id;
    $this.surface1 = surface1;
    $this.surface2 = surface2;
    $this.vertex1 = vertex1;
    $this.vertex2 = vertex2;
    return $this;
  }
  function RoomEdgeTestImpl_init_$Create$(seen1, id, surface1, surface2, vertex1, vertex2, serializationConstructorMarker) {
    return RoomEdgeTestImpl_init_$Init$(seen1, id, surface1, surface2, vertex1, vertex2, serializationConstructorMarker, objectCreate(protoOf(RoomEdgeTestImpl)));
  }
  function RoomEdgeTestImpl(id, surface1, surface2, vertex1, vertex2) {
    this.id = id;
    this.surface1 = surface1;
    this.surface2 = surface2;
    this.vertex1 = vertex1;
    this.vertex2 = vertex2;
  }
  protoOf(RoomEdgeTestImpl).s1k = function () {
    return this.id;
  };
  protoOf(RoomEdgeTestImpl).s3k = function () {
    return this.surface1;
  };
  protoOf(RoomEdgeTestImpl).t3k = function () {
    return this.surface2;
  };
  protoOf(RoomEdgeTestImpl).u3k = function () {
    return this.vertex1;
  };
  protoOf(RoomEdgeTestImpl).v3k = function () {
    return this.vertex2;
  };
  function Companion_2() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h4f_1 = [null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance()), new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance())];
  }
  protoOf(Companion_2).l17 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_5;
  function Companion_getInstance_2() {
    if (Companion_instance_5 == null)
      new Companion_2();
    return Companion_instance_5;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomCornerTestImpl', this, 4);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('position', false);
    tmp0_serialDesc.cv('surfaces', false);
    tmp0_serialDesc.cv('edges', false);
    this.i4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ok = function () {
    return this.i4f_1;
  };
  protoOf($serializer_2).rv = function () {
    var tmp0_cached = Companion_getInstance_2().h4f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_3(), tmp0_cached[2], tmp0_cached[3]];
  };
  protoOf($serializer_2).qk = function (decoder) {
    var tmp0_desc = this.i4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance_2().h4f_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return RoomCornerTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_2).j4f = function (encoder, value) {
    var tmp0_desc = this.i4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().h4f_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_3(), value.position);
    tmp1_output.ep(tmp0_desc, 2, tmp2_cached[2], value.surfaces);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.edges);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_2).pk = function (encoder, value) {
    return this.j4f(encoder, value instanceof RoomCornerTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function RoomCornerTestImpl_init_$Init$(seen1, id, position, surfaces, edges, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_2().i4f_1);
    }
    $this.id = id;
    $this.position = position;
    $this.surfaces = surfaces;
    $this.edges = edges;
    return $this;
  }
  function RoomCornerTestImpl_init_$Create$(seen1, id, position, surfaces, edges, serializationConstructorMarker) {
    return RoomCornerTestImpl_init_$Init$(seen1, id, position, surfaces, edges, serializationConstructorMarker, objectCreate(protoOf(RoomCornerTestImpl)));
  }
  function RoomCornerTestImpl(id, position, surfaces, edges) {
    Companion_getInstance_2();
    this.id = id;
    this.position = position;
    this.surfaces = surfaces;
    this.edges = edges;
  }
  protoOf(RoomCornerTestImpl).s1k = function () {
    return this.id;
  };
  protoOf(RoomCornerTestImpl).ct = function () {
    return this.position;
  };
  protoOf(RoomCornerTestImpl).l23 = function () {
    return this.surfaces;
  };
  protoOf(RoomCornerTestImpl).n3j = function () {
    return this.edges;
  };
  function Companion_3() {
  }
  protoOf(Companion_3).l17 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_6;
  function Companion_getInstance_3() {
    return Companion_instance_6;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomPoint3DTestImpl', this, 3);
    tmp0_serialDesc.cv('x', false);
    tmp0_serialDesc.cv('y', false);
    tmp0_serialDesc.cv('z', false);
    this.k4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ok = function () {
    return this.k4f_1;
  };
  protoOf($serializer_3).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_3).qk = function (decoder) {
    var tmp0_desc = this.k4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return RoomPoint3DTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_3).l4f = function (encoder, value) {
    var tmp0_desc = this.k4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ap(tmp0_desc, 0, value.x);
    tmp1_output.ap(tmp0_desc, 1, value.y);
    tmp1_output.ap(tmp0_desc, 2, value.z);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_3).pk = function (encoder, value) {
    return this.l4f(encoder, value instanceof RoomPoint3DTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function RoomPoint3DTestImpl_init_$Init$(seen1, x, y, z, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_3().k4f_1);
    }
    $this.x = x;
    $this.y = y;
    $this.z = z;
    return $this;
  }
  function RoomPoint3DTestImpl_init_$Create$(seen1, x, y, z, serializationConstructorMarker) {
    return RoomPoint3DTestImpl_init_$Init$(seen1, x, y, z, serializationConstructorMarker, objectCreate(protoOf(RoomPoint3DTestImpl)));
  }
  function RoomPoint3DTestImpl(x, y, z) {
    this.x = x;
    this.y = y;
    this.z = z;
  }
  protoOf(RoomPoint3DTestImpl).i2d = function () {
    return this.x;
  };
  protoOf(RoomPoint3DTestImpl).j2d = function () {
    return this.y;
  };
  protoOf(RoomPoint3DTestImpl).k2d = function () {
    return this.z;
  };
  function Companion_4() {
  }
  protoOf(Companion_4).l17 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_7;
  function Companion_getInstance_4() {
    return Companion_instance_7;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomObstacleTestImpl', this, 3);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('type', false);
    tmp0_serialDesc.cv('boundingBox', false);
    this.m4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ok = function () {
    return this.m4f_1;
  };
  protoOf($serializer_4).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_6()];
  };
  protoOf($serializer_4).qk = function (decoder) {
    var tmp0_desc = this.m4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return RoomObstacleTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_4).n4f = function (encoder, value) {
    var tmp0_desc = this.m4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.type);
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_6(), value.boundingBox);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_4).pk = function (encoder, value) {
    return this.n4f(encoder, value instanceof RoomObstacleTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function RoomObstacleTestImpl_init_$Init$(seen1, id, type, boundingBox, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_4().m4f_1);
    }
    $this.id = id;
    $this.type = type;
    $this.boundingBox = boundingBox;
    return $this;
  }
  function RoomObstacleTestImpl_init_$Create$(seen1, id, type, boundingBox, serializationConstructorMarker) {
    return RoomObstacleTestImpl_init_$Init$(seen1, id, type, boundingBox, serializationConstructorMarker, objectCreate(protoOf(RoomObstacleTestImpl)));
  }
  function RoomObstacleTestImpl(id, type, boundingBox) {
    this.id = id;
    this.type = type;
    this.boundingBox = boundingBox;
  }
  protoOf(RoomObstacleTestImpl).s1k = function () {
    return this.id;
  };
  protoOf(RoomObstacleTestImpl).a1x = function () {
    return this.type;
  };
  protoOf(RoomObstacleTestImpl).m3k = function () {
    return this.boundingBox;
  };
  function Companion_5() {
  }
  protoOf(Companion_5).l17 = function () {
    return $serializer_getInstance_5();
  };
  var Companion_instance_8;
  function Companion_getInstance_5() {
    return Companion_instance_8;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomRotationTestImpl', this, 4);
    tmp0_serialDesc.cv('x', false);
    tmp0_serialDesc.cv('y', false);
    tmp0_serialDesc.cv('z', false);
    tmp0_serialDesc.cv('w', false);
    this.o4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ok = function () {
    return this.o4f_1;
  };
  protoOf($serializer_5).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_5).qk = function (decoder) {
    var tmp0_desc = this.o4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_input = decoder.nn(tmp0_desc);
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return RoomRotationTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_5).p4f = function (encoder, value) {
    var tmp0_desc = this.o4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ap(tmp0_desc, 0, value.x);
    tmp1_output.ap(tmp0_desc, 1, value.y);
    tmp1_output.ap(tmp0_desc, 2, value.z);
    tmp1_output.ap(tmp0_desc, 3, value.w);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_5).pk = function (encoder, value) {
    return this.p4f(encoder, value instanceof RoomRotationTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function RoomRotationTestImpl_init_$Init$(seen1, x, y, z, w, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_5().o4f_1);
    }
    $this.x = x;
    $this.y = y;
    $this.z = z;
    $this.w = w;
    return $this;
  }
  function RoomRotationTestImpl_init_$Create$(seen1, x, y, z, w, serializationConstructorMarker) {
    return RoomRotationTestImpl_init_$Init$(seen1, x, y, z, w, serializationConstructorMarker, objectCreate(protoOf(RoomRotationTestImpl)));
  }
  function RoomRotationTestImpl(x, y, z, w) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
  }
  protoOf(RoomRotationTestImpl).i2d = function () {
    return this.x;
  };
  protoOf(RoomRotationTestImpl).j2d = function () {
    return this.y;
  };
  protoOf(RoomRotationTestImpl).k2d = function () {
    return this.z;
  };
  protoOf(RoomRotationTestImpl).h2d = function () {
    return this.w;
  };
  function Companion_6() {
  }
  protoOf(Companion_6).l17 = function () {
    return $serializer_getInstance_6();
  };
  var Companion_instance_9;
  function Companion_getInstance_6() {
    return Companion_instance_9;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomBoundingBoxTestImpl', this, 2);
    tmp0_serialDesc.cv('size', false);
    tmp0_serialDesc.cv('transform', false);
    this.q4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ok = function () {
    return this.q4f_1;
  };
  protoOf($serializer_6).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_3(), $serializer_getInstance_7()];
  };
  protoOf($serializer_6).qk = function (decoder) {
    var tmp0_desc = this.q4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return RoomBoundingBoxTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_6).r4f = function (encoder, value) {
    var tmp0_desc = this.q4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_3(), value.size);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_7(), value.transform);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_6).pk = function (encoder, value) {
    return this.r4f(encoder, value instanceof RoomBoundingBoxTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function RoomBoundingBoxTestImpl_init_$Init$(seen1, size, transform, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().q4f_1);
    }
    $this.size = size;
    $this.transform = transform;
    return $this;
  }
  function RoomBoundingBoxTestImpl_init_$Create$(seen1, size, transform, serializationConstructorMarker) {
    return RoomBoundingBoxTestImpl_init_$Init$(seen1, size, transform, serializationConstructorMarker, objectCreate(protoOf(RoomBoundingBoxTestImpl)));
  }
  function RoomBoundingBoxTestImpl(size, transform) {
    this.size = size;
    this.transform = transform;
  }
  protoOf(RoomBoundingBoxTestImpl).n = function () {
    return this.size;
  };
  protoOf(RoomBoundingBoxTestImpl).d1x = function () {
    return this.transform;
  };
  function Companion_7() {
  }
  protoOf(Companion_7).l17 = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_10;
  function Companion_getInstance_7() {
    return Companion_instance_10;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.test.helper.utils.RoomTransformTestImpl', this, 2);
    tmp0_serialDesc.cv('position', false);
    tmp0_serialDesc.cv('rotation', false);
    this.s4f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ok = function () {
    return this.s4f_1;
  };
  protoOf($serializer_7).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_3(), $serializer_getInstance_5()];
  };
  protoOf($serializer_7).qk = function (decoder) {
    var tmp0_desc = this.s4f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return RoomTransformTestImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_7).t4f = function (encoder, value) {
    var tmp0_desc = this.s4f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_3(), value.position);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_5(), value.rotation);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_7).pk = function (encoder, value) {
    return this.t4f(encoder, value instanceof RoomTransformTestImpl ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RoomTransformTestImpl_init_$Init$(seen1, position, rotation, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_7().s4f_1);
    }
    $this.position = position;
    $this.rotation = rotation;
    return $this;
  }
  function RoomTransformTestImpl_init_$Create$(seen1, position, rotation, serializationConstructorMarker) {
    return RoomTransformTestImpl_init_$Init$(seen1, position, rotation, serializationConstructorMarker, objectCreate(protoOf(RoomTransformTestImpl)));
  }
  function RoomTransformTestImpl(position, rotation) {
    this.position = position;
    this.rotation = rotation;
  }
  protoOf(RoomTransformTestImpl).ct = function () {
    return this.position;
  };
  protoOf(RoomTransformTestImpl).v1k = function () {
    return this.rotation;
  };
  function RoomGeometryDataImpl(surfaces, edges, corners, obstacles) {
    obstacles = obstacles === VOID ? null : obstacles;
    this.u4f_1 = surfaces;
    this.v4f_1 = edges;
    this.w4f_1 = corners;
    this.x4f_1 = obstacles;
  }
  protoOf(RoomGeometryDataImpl).l23 = function () {
    return this.u4f_1;
  };
  protoOf(RoomGeometryDataImpl).n3j = function () {
    return this.v4f_1;
  };
  protoOf(RoomGeometryDataImpl).r3k = function () {
    return this.w4f_1;
  };
  protoOf(RoomGeometryDataImpl).o3j = function () {
    return this.x4f_1;
  };
  function RoomSurfaceImpl(id, type, vertices) {
    this.y4f_1 = id;
    this.z4f_1 = type;
    this.a4g_1 = vertices;
  }
  protoOf(RoomSurfaceImpl).s1k = function () {
    return this.y4f_1;
  };
  protoOf(RoomSurfaceImpl).a1x = function () {
    return this.z4f_1;
  };
  protoOf(RoomSurfaceImpl).b23 = function () {
    return this.a4g_1;
  };
  function RoomEdgeImpl(id, surface1, surface2, vertex1, vertex2) {
    this.b4g_1 = id;
    this.c4g_1 = surface1;
    this.d4g_1 = surface2;
    this.e4g_1 = vertex1;
    this.f4g_1 = vertex2;
  }
  protoOf(RoomEdgeImpl).s1k = function () {
    return this.b4g_1;
  };
  protoOf(RoomEdgeImpl).s3k = function () {
    return this.c4g_1;
  };
  protoOf(RoomEdgeImpl).t3k = function () {
    return this.d4g_1;
  };
  protoOf(RoomEdgeImpl).u3k = function () {
    return this.e4g_1;
  };
  protoOf(RoomEdgeImpl).v3k = function () {
    return this.f4g_1;
  };
  function RoomCornerImpl(id, position, surfaces, edges) {
    this.g4g_1 = id;
    this.h4g_1 = position;
    this.i4g_1 = surfaces;
    this.j4g_1 = edges;
  }
  protoOf(RoomCornerImpl).s1k = function () {
    return this.g4g_1;
  };
  protoOf(RoomCornerImpl).ct = function () {
    return this.h4g_1;
  };
  protoOf(RoomCornerImpl).l23 = function () {
    return this.i4g_1;
  };
  protoOf(RoomCornerImpl).n3j = function () {
    return this.j4g_1;
  };
  function RoomPoint3DImpl(x, y, z) {
    this.k4g_1 = x;
    this.l4g_1 = y;
    this.m4g_1 = z;
  }
  protoOf(RoomPoint3DImpl).i2d = function () {
    return this.k4g_1;
  };
  protoOf(RoomPoint3DImpl).j2d = function () {
    return this.l4g_1;
  };
  protoOf(RoomPoint3DImpl).k2d = function () {
    return this.m4g_1;
  };
  //region block: post-declaration
  defineProp(protoOf(RoomGeneratorUtils$createRoomFromData$1), 'surfaces', function () {
    return this.l23();
  });
  defineProp(protoOf(RoomGeneratorUtils$createRoomFromData$1), 'edges', function () {
    return this.n3j();
  });
  defineProp(protoOf(RoomGeneratorUtils$createRoomFromData$1), 'corners', function () {
    return this.r3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$createRoomFromData$1), 'obstacles', function () {
    return this.o3j();
  });
  defineProp(protoOf(RoomGeneratorUtils$point$1), 'x', function () {
    return this.i2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$point$1), 'y', function () {
    return this.j2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$point$1), 'z', function () {
    return this.k2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$surfaces$1$1), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomGeneratorUtils$surfaces$1$1), 'type', function () {
    return this.a1x();
  });
  defineProp(protoOf(RoomGeneratorUtils$surfaces$1$1), 'vertices', function () {
    return this.b23();
  });
  defineProp(protoOf(RoomGeneratorUtils$edges$1$1), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomGeneratorUtils$edges$1$1), 'surface1', function () {
    return this.s3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$edges$1$1), 'surface2', function () {
    return this.t3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$edges$1$1), 'vertex1', function () {
    return this.u3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$edges$1$1), 'vertex2', function () {
    return this.v3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$corners$1$1), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomGeneratorUtils$corners$1$1), 'position', function () {
    return this.ct();
  });
  defineProp(protoOf(RoomGeneratorUtils$corners$1$1), 'edges', function () {
    return this.n3j();
  });
  defineProp(protoOf(RoomGeneratorUtils$corners$1$1), 'surfaces', function () {
    return this.l23();
  });
  defineProp(protoOf(RoomGeneratorUtils$obstacles$1$1), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomGeneratorUtils$obstacles$1$1), 'type', function () {
    return this.a1x();
  });
  defineProp(protoOf(RoomGeneratorUtils$obstacles$1$1), 'boundingBox', function () {
    return this.m3k();
  });
  defineProp(protoOf(RoomGeneratorUtils$boundingBox$1), 'size', function () {
    return this.n();
  });
  defineProp(protoOf(RoomGeneratorUtils$boundingBox$1), 'transform', function () {
    return this.d1x();
  });
  defineProp(protoOf(RoomGeneratorUtils$transform$1), 'position', function () {
    return this.ct();
  });
  defineProp(protoOf(RoomGeneratorUtils$transform$1), 'rotation', function () {
    return this.v1k();
  });
  defineProp(protoOf(RoomGeneratorUtils$rotation$1), 'x', function () {
    return this.i2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$rotation$1), 'y', function () {
    return this.j2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$rotation$1), 'z', function () {
    return this.k2d();
  });
  defineProp(protoOf(RoomGeneratorUtils$rotation$1), 'w', function () {
    return this.h2d();
  });
  protoOf($serializer).sv = typeParametersSerializers;
  protoOf($serializer_0).sv = typeParametersSerializers;
  protoOf($serializer_1).sv = typeParametersSerializers;
  protoOf($serializer_2).sv = typeParametersSerializers;
  protoOf($serializer_3).sv = typeParametersSerializers;
  protoOf($serializer_4).sv = typeParametersSerializers;
  protoOf($serializer_5).sv = typeParametersSerializers;
  protoOf($serializer_6).sv = typeParametersSerializers;
  protoOf($serializer_7).sv = typeParametersSerializers;
  defineProp(protoOf(RoomGeometryDataImpl), 'surfaces', function () {
    return this.l23();
  });
  defineProp(protoOf(RoomGeometryDataImpl), 'edges', function () {
    return this.n3j();
  });
  defineProp(protoOf(RoomGeometryDataImpl), 'corners', function () {
    return this.r3k();
  });
  defineProp(protoOf(RoomGeometryDataImpl), 'obstacles', function () {
    return this.o3j();
  });
  defineProp(protoOf(RoomSurfaceImpl), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomSurfaceImpl), 'type', function () {
    return this.a1x();
  });
  defineProp(protoOf(RoomSurfaceImpl), 'vertices', function () {
    return this.b23();
  });
  defineProp(protoOf(RoomEdgeImpl), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomEdgeImpl), 'surface1', function () {
    return this.s3k();
  });
  defineProp(protoOf(RoomEdgeImpl), 'surface2', function () {
    return this.t3k();
  });
  defineProp(protoOf(RoomEdgeImpl), 'vertex1', function () {
    return this.u3k();
  });
  defineProp(protoOf(RoomEdgeImpl), 'vertex2', function () {
    return this.v3k();
  });
  defineProp(protoOf(RoomCornerImpl), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(RoomCornerImpl), 'position', function () {
    return this.ct();
  });
  defineProp(protoOf(RoomCornerImpl), 'surfaces', function () {
    return this.l23();
  });
  defineProp(protoOf(RoomCornerImpl), 'edges', function () {
    return this.n3j();
  });
  defineProp(protoOf(RoomPoint3DImpl), 'x', function () {
    return this.i2d();
  });
  defineProp(protoOf(RoomPoint3DImpl), 'y', function () {
    return this.j2d();
  });
  defineProp(protoOf(RoomPoint3DImpl), 'z', function () {
    return this.k2d();
  });
  //endregion
  //region block: init
  ArrangeExtensions_instance = new ArrangeExtensions();
  AutoAdaptExtensions_instance = new AutoAdaptExtensions();
  PlacementExtensions_instance = new PlacementExtensions();
  RoomGeneratorUtils_instance = new RoomGeneratorUtils();
  Companion_instance_4 = new Companion_1();
  Companion_instance_6 = new Companion_3();
  Companion_instance_7 = new Companion_4();
  Companion_instance_8 = new Companion_5();
  Companion_instance_9 = new Companion_6();
  Companion_instance_10 = new Companion_7();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$extensions = $com$ikea$core$test$helper.extensions || ($com$ikea$core$test$helper.extensions = {});
    defineProp($com$ikea$core$test$helper$extensions, 'ArrangeExtensions', ArrangeExtensions_getInstance);
    $com$ikea$core$test$helper$extensions.placeHostProductsInLine = placeHostProductsInLine;
    $com$ikea$core$test$helper$extensions.getAlignWidth = getAlignWidth;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$extensions = $com$ikea$core$test$helper.extensions || ($com$ikea$core$test$helper.extensions = {});
    defineProp($com$ikea$core$test$helper$extensions, 'AutoAdaptExtensions', AutoAdaptExtensions_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$extensions = $com$ikea$core$test$helper.extensions || ($com$ikea$core$test$helper.extensions = {});
    defineProp($com$ikea$core$test$helper$extensions, 'PlacementExtensions', PlacementExtensions_getInstance);
    $com$ikea$core$test$helper$extensions.createInSceneAndAssert = createInSceneAndAssert;
    $com$ikea$core$test$helper$extensions.createInHostAndAssert = createInHostAndAssert;
    $com$ikea$core$test$helper$extensions.createAndAlignToTargetAndAssert = createAndAlignToTargetAndAssert;
    $com$ikea$core$test$helper$extensions.createInScene = createInScene;
    $com$ikea$core$test$helper$extensions.createInHost = createInHost;
    $com$ikea$core$test$helper$extensions.createAndSnapToSceneWithAlignment = createAndSnapToSceneWithAlignment;
    $com$ikea$core$test$helper$extensions.createAtPosition = createAtPosition;
    $com$ikea$core$test$helper$extensions.createAtPositionAllowWarnings = createAtPositionAllowWarnings;
    $com$ikea$core$test$helper$extensions.createAtPositionAndAssert = createAtPositionAndAssert;
    $com$ikea$core$test$helper$extensions.fillHostWithProduct = fillHostWithProduct;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$extensions = $com$ikea$core$test$helper.extensions || ($com$ikea$core$test$helper.extensions = {});
    $com$ikea$core$test$helper$extensions.getProductInOrderLeftToRight = getProductInOrderLeftToRight;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$utils = $com$ikea$core$test$helper.utils || ($com$ikea$core$test$helper.utils = {});
    $com$ikea$core$test$helper$utils.CountSystem = CountSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$utils = $com$ikea$core$test$helper.utils || ($com$ikea$core$test$helper.utils = {});
    defineProp($com$ikea$core$test$helper$utils, 'RoomGeneratorUtils', RoomGeneratorUtils_getInstance);
    $com$ikea$core$test$helper$utils.RoomGeometryDataTestImpl = RoomGeometryDataTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomGeometryDataTestImpl, 'Companion', Companion_getInstance);
    $com$ikea$core$test$helper$utils.RoomSurfaceTestImpl = RoomSurfaceTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomSurfaceTestImpl, 'Companion', Companion_getInstance_0);
    $com$ikea$core$test$helper$utils.RoomEdgeTestImpl = RoomEdgeTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomEdgeTestImpl, 'Companion', Companion_getInstance_1);
    $com$ikea$core$test$helper$utils.RoomCornerTestImpl = RoomCornerTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomCornerTestImpl, 'Companion', Companion_getInstance_2);
    $com$ikea$core$test$helper$utils.RoomPoint3DTestImpl = RoomPoint3DTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomPoint3DTestImpl, 'Companion', Companion_getInstance_3);
    $com$ikea$core$test$helper$utils.RoomObstacleTestImpl = RoomObstacleTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomObstacleTestImpl, 'Companion', Companion_getInstance_4);
    $com$ikea$core$test$helper$utils.RoomRotationTestImpl = RoomRotationTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomRotationTestImpl, 'Companion', Companion_getInstance_5);
    $com$ikea$core$test$helper$utils.RoomBoundingBoxTestImpl = RoomBoundingBoxTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomBoundingBoxTestImpl, 'Companion', Companion_getInstance_6);
    $com$ikea$core$test$helper$utils.RoomTransformTestImpl = RoomTransformTestImpl;
    defineProp($com$ikea$core$test$helper$utils.RoomTransformTestImpl, 'Companion', Companion_getInstance_7);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$test = $com$ikea$core.test || ($com$ikea$core.test = {});
    var $com$ikea$core$test$helper = $com$ikea$core$test.helper || ($com$ikea$core$test.helper = {});
    var $com$ikea$core$test$helper$utils = $com$ikea$core$test$helper.utils || ($com$ikea$core$test$helper.utils = {});
    $com$ikea$core$test$helper$utils.RoomGeometryDataImpl = RoomGeometryDataImpl;
    $com$ikea$core$test$helper$utils.RoomSurfaceImpl = RoomSurfaceImpl;
    $com$ikea$core$test$helper$utils.RoomEdgeImpl = RoomEdgeImpl;
    $com$ikea$core$test$helper$utils.RoomCornerImpl = RoomCornerImpl;
    $com$ikea$core$test$helper$utils.RoomPoint3DImpl = RoomPoint3DImpl;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = CountSystem;
  _.$_$.b = ArrangeExtensions_instance;
  _.$_$.c = AutoAdaptExtensions_instance;
  _.$_$.d = PlacementExtensions_instance;
  _.$_$.e = RoomGeneratorUtils_instance;
  //endregion
  return _;
}));

//# sourceMappingURL=core-test-helpers.js.map
